<template> 
<div class="m-1">
    <div class="mb-1">
        <navigation-bar
        v-if="screen_width>Skin.break_point"
            v-bind:skin="Skin"
            v-bind:translation="translation"
            v-bind:language="language"
            v-bind:navigation="gameData.sport_alias ? [
            { name: gameData.sport_alias.toUpperCase(),link:''},
            { name:translate('competitions'),link:'' },
            { name: gameData.country.toUpperCase(),link:''},
            {name: gameData.liga.toUpperCase(),link:''},] : []"
        ></navigation-bar>
    </div>
    <div v-if="gameData" :style="Skin.prematch_event.fondo_data">
        <div :style="Skin.prematch_event.fondo_teams" style="position: relative;" class="p-2">
            <img style="position:absolute;top:0;right:0;height:100%;z-index:0" :src="'https://resources.jbets.online/frontJM/games_backgrounds/'+gameData.sport_alias+'.png'" onerror="this.src=''"/>
            <div class="text-start p-2" style="z-index: 2;position: relative;height: 20%;">
                <span style="font-size:medium">{{ gameData.liga }}</span><br>
            </div>
            <div class="text-center">
                <span style="font-size:small"></span>
            </div>
            <div class="p-2" v-if="gameData.team2_name" style="z-index: 2;position: relative;height: 60%;">
                <div class="p-1 mb-1" style="width:100%;background-color: rgb(0, 0, 0, 0.5);">
                    <img v-if="gameData.team1_name" :src="'https://statistics.betconstruct.com/images/e/m/'+Math.floor(gameData.team1_id / 2000)+'/'+gameData.team1_id+'.webp'" onerror="this.src='https://sport.megafaraon.com/images/icons/defaultSportLogos/1.png'" alt="team" width="18">
                    <!-- <shirt v-bind:color="'#'+(gameData.info.shirt1_color == '000000' ? 'ccc' : gameData.info.shirt1_color)"/> -->
                    <span class="mx-1" :style="Skin.prematch_event.teams_text">{{ gameData.team1_name }}</span>
                </div>
                <div class="p-1 mb-1" style="width:100%;background-color: rgb(0, 0, 0, 0.5);">
                    <img v-if="gameData.team2_name" :src="'https://statistics.betconstruct.com/images/e/m/'+Math.floor(gameData.team2_id / 2000)+'/'+gameData.team2_id+'.webp'" onerror="this.src='https://sport.megafaraon.com/images/icons/defaultSportLogos/1.png'" alt="team" width="18">
                    <!-- <span><shirt2 v-bind:color="'#'+(gameData.info.shirt2_color == '000000' ? 'f00' : gameData.info.shirt2_color)"/></span> -->
                    <span class="mx-1" :style="Skin.prematch_event.teams_text">{{ gameData.team2_name }}</span>
                </div>
                <div class="p-0 text-end">
                    <span class="p-2" style="width:100%;background-color: rgb(0, 0, 0, 0.5);font-size: small;">{{ format_date(gameData.start_ts) }}</span>
                </div>
            </div>
            <div class="p-2" style="z-index: 2;position: relative;height: 20%;">
                <span @click="collapseOdds" style="color:white;font-size: large;cursor: pointer;" class="me-2"><i class="fas fa-angle-double-up"></i></span>
                <span v-if="screen_width>Skin.break_point" @click="changeColumns" style="color:white;font-size: large;cursor: pointer;" class="mx-2"><i class="fas fa-columns"></i></span>
            </div>
        </div>
        <div>
            <allOdds
                v-if="Object.keys(market).length>0"
                v-bind:Skin="Skin"
                v-bind:language="language"
                v-bind:translation="translation"
                v-bind:game="market"
                v-bind:league="gameData.liga"
                ref="allOdds"
            >
            </allOdds>
            <div v-else :style="screen_width<450?'':'width:100%; height:90vh'" class="text-center py-5">
                <div class="spinner-border" :style="Skin.loader" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
    <div v-else :style="Skin.prematch_event.fondo_not_available" style="height:93vh" class="text-center py-5">
        <p>El evento ha finalizado o no se encuentra disponible en este momento.</p>
    </div>
</div>

</template>

<script>
const flags = require('../../../assets/countries.json');
import navigationBar from './navigation/navigation_bar.vue';
import allOdds from '../main_lobby/main_events_prematch2/all_odds.vue';
import shirt from './shirt.vue';
import shirt2 from './shirt2.vue';
export default {
    name: 'prematch2_encuentro',
    components:{
        allOdds,
        navigationBar,
        shirt,
        shirt2,
    },
    props: ['Skin','translation','language','gameData'],
    data(){
            return {
                screen_width:0,
                collapsedOdds:false
            }
        },
    methods:{
        collapseOdds(){
            this.$refs.allOdds.collapse_odds(!this.collapsedOdds);
            this.collapsedOdds = !this.collapsedOdds;
        },
        changeColumns(){
            this.$refs.allOdds.change_qtyColumns();
        },
        sizeControl(){
            this.screen_width=window.innerWidth;
        },
        country_flag(country_name) {
          let flag = ""
          flags.countries.forEach(country => {
              if(country.name_es == country_name || country.name_en == country_name){
                flag=country.code.toLowerCase();
              }
          });
          return flag;
        },
        format_date: function (ts) {
            let date = new Date(ts * 1000);
            var formated =
                date.getFullYear() +
                "-" +
                ("0" + (date.getMonth() + 1)).slice(-2) +
                "-" +
                ("0" + date.getDate()).slice(-2) +
                " " +
                date.getHours() +
                ":" +
                ("0" + date.getMinutes()).slice(-2) +
                ":" +
                ("0" + date.getSeconds()).slice(-2);
            return formated;
        },
        translate(text) {
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
    }, 
    computed:{
        market(){
            if(!("mode" in this.$props.gameData)){
                let data = this.$store.getters['prematch_2/getSuscribeEventsMarket'];
                if(data[this.$props.gameData.id] != null){
                    if(data[this.$props.gameData.id].data.data.sport[this.$props.gameData.sport_id??this.$props.gameData.sport]){
                        let game = data[this.$props.gameData.id].data.data.sport[this.$props.gameData.sport_id??this.$props.gameData.sport].region[this.$props.gameData.country_id].competition[this.$props.gameData.liga_id].game[this.$props.gameData.id];
                        return game;
                    }
                }
            }
            else{
                return this.$props.gameData;
            }
            return {};
        }
    },
    created() {
        this.sizeControl();
    },
    mounted(){
        window.addEventListener('resize', ()=>{this.sizeControl();});
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.long_text {
  display: -webkit-box;
  max-width: 200px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

</style>
